import { combineReducers } from "redux";

// :::::::::::::: vivn user :::::::::::::::://
import userAuthReducer from "./user/auth/user_auth.reducer";
import loginReducer from "./user/login/login.reducer";
import supporterReducer from "./user/supporter/supporter.reducer";

// :::::::::::::: vivn main :::::::::::::::://
import bailiffAuthReducer from "./bailiff/auth/bailiff_auth.reducer";
import draftDialogReducer from "./bailiff/task/dialog/draft_dialog.reducer";
import taskEffortReducer from "./bailiff/task/effort/task_effort.reducer";
import navReducer from "./bailiff/nav/nav.reducer";
import financeSupporterReducer from "./bailiff/finance/supporter/finance_supporter.reducer";
import financeLifeReducer from "./bailiff/finance/life/life.reducer";
import defaultWalletReducer from "./bailiff/default/wallet/default_wallet.reducer";
import settingWithdrawReducer from "./bailiff/default/withdraw/setting_withdraw.reducer";
import paymentWithdrawReducer from "./bailiff/payment/withdraw/payment_withdraw.reducer";
import defaultBankReducer from "./bailiff/default/bank/default_bank.reducer";
import notificationReducer from "./bailiff/notification/notification.reducer";
import taskCountReducer from "./bailiff/task/task_count/task_count.reducer";

const rootReducer = combineReducers({
  //auth
  userAuthReducer,
  bailiffAuthReducer,
  loginReducer,

  //supporter.
  supporterReducer,

  // finance
  financeSupporterReducer,
  financeLifeReducer,

  // draft
  draftDialogReducer,
  taskEffortReducer,

  //banks
  paymentWithdrawReducer,
  defaultBankReducer,

  //setting.
  settingWithdrawReducer,

  //wallet
  defaultWalletReducer,

  //noti
  notificationReducer,

  //nav
  navReducer,

  //exxtra
  taskExtraReducer: taskCountReducer,
});

export default rootReducer;
